import * as angular from "angular";
import {IController, ITimeoutService} from "angular";
import * as _ from "lodash"
import {PlanningAlertsService} from "../../services/planning-alerts.service";
import {PlanningCommonService} from "../../services/planning-coomon-service.service";
import {PlanningDialogService} from "../../services/planning-dialogs-service.service";
import {PlanningDraftsService} from "../../services/planning-drafts-service.service";
import {PlanningProjectsService} from "../../services/planning-projects-service.service";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {SiteFiltersType} from "../../../commons/types/site-filters.type";

export class PlanningProjectViewCtrl implements IController {

  project: any;
  jobs: any;
  resources: any;
  depots: any;
  draftTemplate: any;
  projectTemplate: any;

  public selectedJobIds: any[];
  public selectedResourceIds: any[];
  public selectedJobToView: {};
  public sortJobsSlaType: boolean | "desc" | "asc";
  public filterConfig: {
    jobsQueryString: string,
    resourcesQueryString: string,
    jobsSelectedServiceAreasIds: string[],
    resourcesSelectedServiceAreasIds: string[],
    jobsSelectedSkills: any,
    resourcesSelectedSkills: any,
    jobsIsPackedQuery: any,
    resourcesInRouteQuery: any,
    jobsSelectedTagNames: any
  }
  public serviceAreas: any[];
  public sortBy: any;
  public sortByType: any = 'asc';

  private projectRef: any;
  private projectsProcessTrackingRef: any;
  private serviceAreasRef: any;
  private excludeMode: boolean;
  private selectedJobSourceType: any;
  private loadingState: any;
  private selectedTab: string;
  private stops: any;

  /* @ngInject */
  constructor(private $log, private commonsDialogService: CommonsDialogService, private $planningProjects, private $serviceArea, private commonsService: CommonsService,
              private $planningProjectsProcessTracking, private planningConstants, private planningDialogService: PlanningDialogService,
              private planningAlertsService: PlanningAlertsService, private planningProjectsService: PlanningProjectsService, private planningDraftsService: PlanningDraftsService,
              private $state, private $filter, private $timeout: ITimeoutService, private planningCommonService: PlanningCommonService,
              private moment) {
    this.serviceAreasRef = this.$serviceArea();
    this.loadingState = this.planningProjectsService.getLoading;
    this.projectsProcessTrackingRef = this.$planningProjectsProcessTracking();

  }

  $onInit() {
    this.excludeMode = true;
    this.selectedJobIds = [];
    this.selectedResourceIds = [];
    this.filterConfig = {
      jobsQueryString: undefined,
      resourcesQueryString: undefined,

      jobsSelectedServiceAreasIds: undefined,
      resourcesSelectedServiceAreasIds: undefined,

      jobsSelectedSkills: undefined,
      resourcesSelectedSkills: undefined,

      jobsIsPackedQuery: undefined,
      resourcesInRouteQuery: undefined,
      jobsSelectedTagNames: undefined
    }

    this.selectedTab = 'Services';
    this.sortJobsSlaType = 'desc';

    this.projectRef = this.$planningProjects(this.project.id)

    if (!_.isEmpty(this.jobs)) {
      this.jobs = this._getSortedJobs(this.jobs);
      this.onJobsUpdate(this.jobs);
    }

    if (!_.isEmpty(this.resources)) {
      this.onResourcesUpdate(this.resources);
    }

    if (!this.serviceAreas) {
      this.serviceAreas = [];
    }

    this.setProjectData(this.project);
    this.bindProjectEventListener();
    this.bindProjectProcessEventListener()
  }

  $onDestroy() {
    this.projectsProcessTrackingRef.$destroyChannel();

    // Safety net: if a create-draft loader is still up when this view is torn down (e.g. the
    // request never resolved before the user navigated away), close it before its parent DOM node
    // (#planning-project-view-container) is destroyed - otherwise $mdDialog never gets a chance to
    // clean up after itself and leaves document.body stuck with the "md-dialog-is-showing" class.
    this.planningDialogService.ProjectOptimizingLoader(false);
  }

  // ******************************
  //        Public methods
  // ******************************

  // Project
  // onEditProjectDetails($event) {
  //   this.PlanningDialogService.updateProjectDetails(this.project, $event)
  //     .then((updatedProjectDetails) => {
  //       return this.planningProjectsService.updateProjectDetails(updatedProjectDetails)
  //     })
  //     .then(  (updatedProject) => {
  //       this.project.name = updatedProject.name;
  //     })
  //     .catch( ()=> {
  //       this.$log.info('Dialog Closed')
  //     })
  // }



  // Jobs
  onJobsQueryChange(query) {
    this.filterConfig.jobsQueryString = query;
  }

  //     onSelectJobsSourceType(sourceType) { // Hidden in view
  //   this.selectedJobSourceType = sourceType === 'undefined' ? undefined : sourceType;
  // }
  onSortJobsSlaTypeChange(sortJobsSlaType) {
    this.sortJobsSlaType = sortJobsSlaType;
    this.jobs = this._getSortedJobs(this.jobs);
  }

  onSortByChange(sortBy, sortByType) {
    this.sortBy = sortBy;
    this.sortByType = sortByType;
    this.jobs = this._getSortedJobs(this.jobs);
  }

  onJobsFiltersChange(skills, serviceAreaIds, tagNames, resourceIds, inRoute, isPacked) {
    this.filterConfig.jobsSelectedSkills = skills;
    this.filterConfig.jobsSelectedServiceAreasIds = serviceAreaIds;
    this.filterConfig.jobsSelectedTagNames = tagNames;
    this.filterConfig.resourcesInRouteQuery = inRoute;
    this.filterConfig.jobsIsPackedQuery = isPacked;
    this.selectedJobIds = [];
  }

  onJobSelect(jobId) {
    if (!_.includes(this.selectedJobIds, jobId)) {
      this.selectedJobIds = this.selectedJobIds.concat([jobId]);
    } else {
      this.selectedJobIds = _.filter(this.selectedJobIds, function (id) {
        return id !== jobId;
      })
    }
    this.jobs = this._getSortedJobs(this.jobs);
  }

  onSelectedJobsChange(jobIds) {
    this.selectedJobIds = jobIds;
    this.jobs = this._getSortedJobs(this.jobs);
  }

  onSelectedResourcesChange(resourceIds) {
    this.selectedResourceIds = resourceIds;
    this.resources = this._getSortedResources(this.resources);
  }

  onLeftOverJobSelect(jobId) {
    this.$log.info(jobId);
    if (!_.includes(this.selectedJobIds, jobId)) {
      this.selectedJobIds = this.selectedJobIds.concat([jobId]);
    } else {
      this.selectedJobIds = _.filter(this.selectedJobIds, function (id) {
        return id !== jobId;
      })
    }
    this.jobs = this._getSortedJobs(this.jobs);
  }

  onViewJob(jobId: string) {
    this.selectedTab = 'Services';
    this.selectedJobToView = _.find(this.jobs, (j) => {
      return j.id === jobId;
    });
  }

  // onAddJob(event) {
  //   this.planningDialogService.addJob(event, this.project)
  //     .then((jobToCreate) => {
  //       return this.planningProjectsService.addJobs([jobToCreate], this.project);
  //     })
  //     .catch(() => {
  //       this.$log.info('Dialog Closed')
  //     })
  // }

  onAddOrders(event) {
    this.planningDialogService.addOrders(event, this.project, this.projectTemplate)
      .then((payload) => {
        // this.PlanningDialogService.ProjectOptimizingLoader(true, event);
        return this.planningProjectsService.addOrders(payload, this.project.id);
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  onAddServices(event) {
    this.planningDialogService.addServices(event, this.project, this.projectTemplate)
      .then((payload) => {
        return this.planningProjectsService.addServices(payload, this.project.id);
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  // onAddSteps(event) {
  //   this.PlanningDialogService.addSteps(event, this.project)
  //     .then((payload) => {
  //       return this.planningProjectsService.addSteps(
  //         payload.from,
  //         payload.to,
  //         payload.statuses,
  //         payload.branchIds,
  //         payload.accountIds,
  //         payload.serviceAreaIds,
  //         payload.attempts,
  //         payload.tagNames,
  //         payload.schedulingRequired,
  //         this.project
  //       );
  //     })
  //     .catch(() => {
  //       this.$log.info('Dialog Closed')
  //     })
  // }

  onAddFulfillments(event) {
    this.planningDialogService.addSteps(event, this.project)
      .then((filters) => {
        const FulfillmentExtFilter = {
          stepFilter: {
            from: this.moment(filters.from).valueOf(),
            to: this.moment(filters.to).valueOf(),
            accountIds: filters.accountIds,
            vehicleIds: filters.vehicleIds,
            schedulingRequired: filters.schedulingRequired,
            noFromLocation: filters.noFromLocation,
            noToLocation: filters.noToLocation,
            obligateTimeWindow: filters.obligateTimeWindow,
            isReturn: filters.isReturnDelivery,
            branchIds: filters.branchIds,
            serviceAreaIds: filters.serviceAreaIds,
            tags: filters.tags,
            excludedTags: filters.excludedTags,
            routed: filters.inRoute,
            programTypes: filters.programIds,
            approvalStatuses: filters.approvalStatuses,
            types: filters.serviceTypes,
            displayStatuses: filters.displayStatuses,
            depotIds: filters.depotIds,
            filterByCreatedAt: filters.filterByCreatedAt,
            agentIds: filters.agentIds,
            firstMile: filters.fulfillmentMileType === 'firstMile' ? true : undefined,
            middleMile: filters.fulfillmentMileType === 'middleMile' ? true : undefined,
            lastMile: filters.fulfillmentMileType === 'lastMile' ? true : undefined
          },
          fulfillmentFilter: {
            packageTypes: filters.packagesIds?.length ? filters.packagesIds : undefined
          }
        }
        this.planningProjectsService.addFulfillments(FulfillmentExtFilter, this.project.id);
      })
      .catch((error) => {
        this.$log.info('Dialog Closed')
      })
  }

  //used at template
  // onEditJob(job, event) {
  //   this.planningDialogService.editJob(job, this.project, event)
  //     .then((editedJob) => {
  //       this.updateJob(editedJob, this.project);
  //     })
  //     .catch(() => {
  //       this.$log.info('Dialog Closed')
  //     })
  // }

  onDeleteJob(job) {
    this.onDeleteJobs([job.id])
  }

  onDeleteJobs(jobIds) {
    if (this.project.draftsIds?.length) {
      this.commonsDialogService.infoDialog('Can not apply action', 'Can not remove services as there are existing drafts. You may exclude the resource on the Draft level');
      return;
    }
    this.planningProjectsService.deleteJobs(jobIds, this.project)
      .then((deletedJobIds) => {
        this.onJobsDeleted(deletedJobIds);
      });
  }

  updateJobPriority(job, project) {
    this.planningProjectsService.updateJob(job, project)
      .then((updatedJob: any) => {
        const jobsCopy = angular.copy(this.jobs);
        const jobIndex = _.findIndex<any>(jobsCopy, (j) => {
          return j.id === updatedJob.id
        });

        jobsCopy.splice(jobIndex, 1, updatedJob);
        this.jobs = this._getSortedJobs(jobsCopy);
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  // Resources
  onResourcesQueryChange(query) {
    this.filterConfig.resourcesQueryString = query;
  }

  onResourcesFiltersChange(skills, serviceAreaIds, inRoute) {
    this.filterConfig.resourcesSelectedSkills = skills;
    this.filterConfig.resourcesSelectedServiceAreasIds = serviceAreaIds;
    this.filterConfig.resourcesInRouteQuery = inRoute;
  }

  onAddResourcesClick(event) {
    const actions = this.planningConstants.resourceActions;

    this.commonsService.openActionPanel(actions, event)
      .then((reason: any) => {
        if (reason.key === 'ALLOCATIONS') {
          this.selectAllocationResources(event);
        }
        if (reason.key === 'VEHICLES') {
          this.selectVehicleResources(event);
        }
      })
      .catch((reason) => {
        this.$log.info('Action Panel Closed', reason);
      });
  }

  onAddResourcesByType(type, event) {
    if (type === 'Allocations') {
      this.selectAllocationResources(event);
    }
    if (type === 'Vehicles') {
      this.selectVehicleResources(event);
    }
  }

  selectAllocationResources(event) {
    const resources = angular.copy(this.resources);
    _.forEach(resources, (r) => {
      _.set(r, 'id', r.allocationId + '_' + r.startTime + '_' + r.endTime);
    })
    const currentResourceIds = _.map(resources, 'allocationId');
    this.planningDialogService.selectAllocationResources(this.project.from, this.project.to,
      this.project.id, this.project.branchIds, currentResourceIds, {[SiteFiltersType.tags]: true}, true, event, this.draftTemplate)
      .then((payload) => {
        if (payload.selectedResources && payload.selectedResources.length) {
          this.addResourcesToProject(payload.selectedResources, payload.importAllocationResourcesServiceTemplate);
        }
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  selectVehicleResources(event) {
    const currentResourceIds = _.map(this.resources, 'vehicleId');
    this.planningDialogService.selectVehicleResources(this.project.from, this.project.to,
      this.project.id, this.project.branchIds, currentResourceIds, event)
      .then((selectedResources) => {
        if (selectedResources && selectedResources.length) {
          this.addResourcesToProject(selectedResources);
        }
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  selectAgentsScheduleResources(event) {
    const currentResourceIds = _.map(this.resources, 'instanceResourceId');
    this.planningDialogService.selectAgentsScheduleResources(this.project.from, this.project.to,
      this.project.id, this.project.branchIds, currentResourceIds, {[SiteFiltersType.tags]: true}, event)
      .then((selectedResources) => {
        if (selectedResources && selectedResources.length) {
          this.addResourcesToProject(selectedResources);
        }
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  onDeleteResources(ids) {
    if (this.project.draftsIds?.length) {
      this.commonsDialogService.infoDialog('Can not apply action', 'Can not remove resources as there are existing drafts. You may exclude the resource on the Draft level');
      return;
    }
    this.planningProjectsService.deleteResources(ids, this.project)
      .then((deletedResourceIds: any) => {
        this.resources = _.filter(this.resources, (r) => {
          return _.indexOf(deletedResourceIds, r.id) === -1
        });
      });
  }

  // // Depots
  // onSelectDepotsToProject(event) {
  //   const currentDepots = _.get(this.project, 'depots', []);
  //   this.PlanningDialogService.selectDepots(this.project.id, currentDepots, event)
  //     .then((selectedDepots) => {
  //       return this.planningProjectsService.addDepots(selectedDepots, this.project)
  //     })
  //     .then((depotsAdded) => {
  //       if (!this.depots) {
  //         this.depots = [];
  //       }
  //       this.depots = this.depots.concat(depotsAdded);
  //     })
  //     .catch(() => {
  //       this.$log.info('Dialog Closed')
  //     })
  // }

  // onDeleteDepotFromProject(depot) {
  //   this.planningProjectsService.deleteDepots([depot.id], this.project)
  //     .then((deletedDepotIds) => {
  //       this.depots = _.filter(this.depots, (d) => {
  //         return _.indexOf(deletedDepotIds, d.id) === -1
  //       });
  //     });
  // }

  // Drafts
  onCreateDraft(event) {

    if (!this.jobs || !this.jobs.length) {
      this.planningAlertsService.createDraftNoStopsInfo();
      return;
    }

    if (!this.resources || !this.resources.length) {
      this.planningAlertsService.createDraftNoResourcesInfo();
      return;
    }

    const excludeJobIds = _.chain(this.jobs)
      .filter((j) => {
        return !_.includes(this.selectedJobIds, j.id);
      })
      .map('id')
      .value();

    let jobsCopy = _.orderBy(this.jobs, [this.sortBy], [this.sortByType]);

    const selectedJobs = _.filter(jobsCopy, (j: any) => {
      return _.includes(this.selectedJobIds, j.id);
    })

    const excludeResourceIds = _.chain(this.resources)
      .filter((r) => {
        return !_.includes(this.selectedResourceIds, r.id);
      })
      .map('id')
      .value();

    const depots = this.depots || [];
    this.planningDialogService.createDraft(this.project, depots, selectedJobs, undefined, event)
      .then((draftSettings) => {
        // ctrl.excludeMode = ctrl.selectedJobIds.length > ctrl.jobs.length/2;

        this.planningDialogService.ProjectOptimizingLoader(true);
        return this.planningDraftsService.createDraft(draftSettings.settings, draftSettings.draftName, excludeJobIds, excludeResourceIds, this.project.id, draftSettings.isOptimizedDraft, draftSettings.draftTemplateId, draftSettings.useDraftTemplateSettings)
          .then((createdDraft: any) => {
            this.planningDialogService.ProjectOptimizingLoader(false);
            this.project.selectedDraftId = createdDraft.id;
            // $state.go('^.draft', {draftId: createdDraft.id}, {notify: true, reload: 'planning.project.scheme.draft'});
            this.$state.go('^.draft', {draftId: createdDraft.id}, {notify: true, reload: false});
          })
          .catch((err) => {
            // The loader was already open for this attempt - make sure it's closed even though
            // creation failed, otherwise it's left showing with nothing left to hide it.
            this.planningDialogService.ProjectOptimizingLoader(false);
            this.planningAlertsService.createDraftInProjectError();
          });
      })
      .catch((err) => {
        this.$log.info('Dialog Closed');
      })
  }

  onCreateEmptyDraft(event) {

    if (!this.jobs || !this.jobs.length) {
      this.planningAlertsService.createDraftNoStopsInfo();
      return;
    }

    if (!this.resources || !this.resources.length) {
      this.planningAlertsService.createDraftNoResourcesInfo();
      return;
    }

    const excludeJobIds = _.chain(this.jobs)
      .filter((j) => {
        return !_.includes(this.selectedJobIds, j.id);
      })
      .map('id')
      .value();

    const excludeResourceIds = _.chain(this.resources)
      .filter((r) => {
        return !_.includes(this.selectedResourceIds, r.id);
      })
      .map('id')
      .value();

    this.planningDialogService.ProjectOptimizingLoader(true);
    this.planningDraftsService.createEmptyDraft(this.project.settings, undefined, excludeJobIds, excludeResourceIds, this.project.id, false)
      .then((createdDraft: any) => {
        this.planningDialogService.ProjectOptimizingLoader(false);
        this.project.selectedDraftId = createdDraft.id;
        this.$state.go('^.draft', {draftId: createdDraft.id}, {notify: true, reload: false});
      })
      .catch((err) => {
        this.planningDialogService.ProjectOptimizingLoader(false);
        this.planningAlertsService.createDraftInProjectError();
      })
  }

  onOpen($mdMenu, ev) {
    this.$timeout(0).then(() => {
      $mdMenu.open(ev);
    });
  }

  // ******************************
  //        Private methods
  // ******************************

  private bindProjectEventListener() {
    this.projectRef.$registerOnUpdateHandler(this, (updatedProject) => {
      if (_.isEqual(this.project.id, updatedProject.id) &&
        (updatedProject.updatedAt > this.project.updatedAt)) {
        this.setProjectData(updatedProject);
      }
    });
  }

  private bindProjectProcessEventListener() {
    this.projectsProcessTrackingRef.$subscribeToChannelEvents((createdProcesses, action) => {
      const projectProcess = _.find(createdProcesses, (process) => {
        return process.processId === this.project.id;
      })
      if (projectProcess?.processStatus === 'IN_PROGRESS') {
        this.planningDialogService.ProjectImportLoader(projectProcess);
      }
    });
  }

  private setProjectData(updatedProject) {

    this.project = updatedProject;

    // Project Statuses - SCHEME/RUNNING/COMPLETED/DISPATCHED
    this.$log.info('Project Status:', updatedProject.status);

    if (_.isEqual(updatedProject.status, 'SCHEME')) {
      // this.PlanningDialogService.ProjectOptimizingLoader(false);

      this.getProjectJobs();
      this.getProjectResources();

      // Jobs Out Of Project Warning
      if (updatedProject.settings.considerTimeWindows) {

        const jobsOutOfProjectScope = this.getJobsOutOfProjectScope(updatedProject)

        if (jobsOutOfProjectScope.length) {
          // TODO connect to new flow
          // this.PlanningDialogService.jobsOutOfProjectScope(jobsOutOfProjectScope)
          //   .then((ignoreTimeWindows) => {
          //     if (ignoreTimeWindows) {
          //       const settingsToUpdate = angular.copy(this.project.settings);
          //       settingsToUpdate.considerTimeWindows = false;
          //       this.updateProjectSettings(settingsToUpdate)
          //     }
          //   })
        }

      }
    }

    // if (_.isEqual(updatedProject.status, 'IMPORT')) {
    //   this.planningProjectProcessTrackingRequestsService.getProjectProcesses(this.project.id, 'IN_PROGRESS').then(processes => {
    //     if (processes.length) {
    //       this.PlanningDialogService.ProjectImportLoader(this.project.id, processes[processes.length - 1]);
    //     } else {
    //       this.planningProjectProcessTrackingRequestsService.getProjectProcesses(this.project.id).then(processes => {
    //         this.PlanningDialogService.ProjectImportLoader(this.project.id, processes[processes.length - 1]);
    //       })
    //     }
    //   }).catch((error) => {
    //     this.$log.error('Failed to get batch progress', error);
    //   })
    // }


  }

  private updateJob(job, project) {
    this.planningProjectsService.updateJob(job, project)
      .then((updatedJob: any) => {
        const jobsCopy = angular.copy(this.jobs);
        const jobIndex = _.findIndex<any>(jobsCopy, (j) => {
          return j.id === updatedJob.id
        });

        jobsCopy.splice(jobIndex, 1, updatedJob);
        this.jobs = this._getSortedJobs(jobsCopy);
        // ctrl.projectJobsByStatus = _setJobsByStatus(jobsCopy);

        if (!project.selectedDraftId) {
          this.stops = this.getStopsFromJobs(this.jobs);
        }
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  private addResourcesToProject(resources, importAllocationResourcesServiceTemplate?: boolean) {
    this.planningProjectsService.addResources(resources, this.project, importAllocationResourcesServiceTemplate)
      .then((resourcesAdded) => {
        if (!this.resources) {
          this.resources = [];
        }
        this.resources = this.resources.concat(resourcesAdded);
        this.onResourcesUpdate(this.resources);
      })
  }

  private onJobsDeleted(deletedJobIds) {
    const filteredJobs = _.filter(this.jobs, (j) => {
      return !_.includes(deletedJobIds, j.id);
    });
    this.jobs = this._getSortedJobs(filteredJobs);
    this.selectedJobIds = [];

    if (!this.project.selectedDraftId) {
      this.stops = this.getStopsFromJobs(this.jobs);
    }
  }


  private getStopsFromJobs(jobs) {
    const stops = [];

    _.forEach(jobs, (j) => {
      _.forEach(j.stops, (s) => {
        stops.push(s);
      })
    });
    return stops;
  }


  private updateProjectSettings(settings) {
    return this.planningProjectsService.updateProjectSettings(settings, this.project.id)
      .then((updatedSettings) => {
        this.project.settings = updatedSettings;
      })
  }

  private getJobsOutOfProjectScope(project) {
    if (!this.jobs) {
      return [];
    }
    return _.filter(this.jobs, (j) => {
      const stopsRef = _.get(j, 'stops', []),
        jobNotBefore = _.get(stopsRef, '[0].notBefore'),
        lastStopRef = stopsRef[stopsRef.length - 1],
        jobNotAfter = _.get(lastStopRef, 'notBefore');

      if (jobNotBefore && jobNotAfter) {
        return jobNotBefore < project.from || jobNotAfter > project.to;
      } else {
        return false;
      }
    })
  }


  getProjectJobs() {
    this.planningProjectsService.getJobs(this.project.id)
      .then((jobs) => {
        this.jobs = this._getSortedJobs(jobs);
        this.onJobsUpdate(jobs);
      })
  }

  getProjectResources() {
    this.planningProjectsService.getResources(this.project.id)
      .then((resources) => {
        this.resources = resources;
        this.onResourcesUpdate(resources);
      })
  }

  private onJobsUpdate(jobs) {
    this.stops = this.getStopsFromJobs(jobs);
    this.selectedJobIds = _.map(jobs, 'id');
    this.setServiceAreasByJobs(jobs);
  }

  private onResourcesUpdate(resources) {
    this.selectedResourceIds = _.map(resources, 'id');
    this.resources = this._getSortedResources(this.resources);
  }

  private setServiceAreasByJobs(jobs) {
    const areaIds = _.chain(jobs)
      .map('areaIds')
      .flatten()
      .uniq()
      .value();

    this.serviceAreasRef.$asyncValues(areaIds)
      .then((serviceAreas) => {
        this.serviceAreas = _.uniqBy(this.serviceAreas.concat(serviceAreas), 'areaId');
      })
  }

  private _getSortedJobs(jobs) {

    _.forEach(jobs, (j) => {
      j.spotsAmount = this.$filter('orderSpots')(j.packages);
      j.packagesAmount = this.$filter('servicePackagesCount')(j.packages);
    })

    let jobsCopy = _.orderBy(jobs, [this.sortBy], [this.sortByType]);

    // all the selected jobs will be on top
    const selectedJobs = _.filter(jobsCopy, (j: any) => {
      return _.includes(this.selectedJobIds, j.id);
    })
    const unselectedJobs = _.filter(jobsCopy, (j: any) => {
      return !_.includes(this.selectedJobIds, j.id);
    })
    return _.concat(selectedJobs, unselectedJobs);
  }

  private _getSortedResources(resources) {

    // all the selected resources will be on top
    const selected = _.filter(resources, (r) => {
      return _.includes(this.selectedResourceIds, r.id);
    })
    const unselected = _.filter(resources, (r) => {
      return !_.includes(this.selectedResourceIds, r.id);
    })
    return _.concat(selected, unselected);
  }

}

angular
  .module('bringoz.admin.planning')
  .component('planningProjectView', {
    bindings: {
      project: '<',
      jobs: '<',
      resources: '<',
      depots: '<',
      draftTemplate: '<',
      projectTemplate: '<'
    },
    template: require('./planning-project-view.html').default,
    controller: PlanningProjectViewCtrl
  });
